import React, { Component,useCallback,useEffect,useState } from "react";
import styled from "styled-components";
import { Ptag, Input, LargeButton, RenderDropDown, Icons,OverlayLoader } from '../components/core'
import { Formik, Form } from "formik";
import * as Yup from "yup";
import http from "../services/httpService";
import {  useNavigate, useParams } from "react-router-dom";
import SideNav from "../components/sideNav";
import SideNavContent from "../components/sideNavContent";
import routes from "../components/routes";
import upload from '../assets/images/upload.png'
import config from '../config.json'
import axios from 'axios'


const GMC_Business_type = ['gmc_non_maternity']

const About =()=> {
  const [loading,setLoading] = useState(true)
  const [is_click,setIsClick] = useState(false)
  const userplan_id = localStorage.getItem('userplan_id') || sessionStorage.getItem('userplan_id') || ''
  const [initialValues, setInitialValues] = useState({})
  const [maternityLimitShow, setMaternityLimit] = useState(false)
  const flow = localStorage.getItem('flow')
  const {type} = useParams()


  const [policyTypes, setPolicyType] = useState([])
  const [business_type, setBusinessType] = useState([])
  const [sbo_insurers, setSboInsurers] = useState([])
  const [insurer_name, setInsurerName] = useState([])
  const [benefit_types, setBenefitTypes] = useState([])
  const [room_types, setRoomTypes] = useState([])
  const [maternity_types, setMaternityTypes] = useState([])
  const [sum_insured_list, setSumInsuredList] = useState([])
  const [insurers, setInsurers] = useState([])
  const [discount_type, setDiscountType ] = useState([])
  const [dependent_type, setDependents] = useState([])
  const [AccidentCoverAmount, setupAccidentCoverAmout] = useState([])


  const showSidebar = () => {
    return !!localStorage.getItem('userplan_id')
  }

  const getInitialValues = async  () => {
    
    
    let benefitsTypesLocal = {}
    if(flow === 'GMC'){
      const  {data} = await http.get('/business/get_gmc_benefit_types/')

      // const benefitList = benefitsObj[GMC_Business_type[0]]
      // const insurerList = Object.keys(benefitList)
      // setInsurers(insurerList)
      // benefitsTypesLocal = {...benefitList}
      // setBenefitTypes(benefitsTypesLocal)
      setInsurers(data['insurers'])
      // setInsurerName(data['insurers'])
      setBusinessType(data['business_type'])
      setSboInsurers(data['insurers'])
      setBenefitTypes(data['benefit_type'])
      setRoomTypes(data['room_type'])
      setMaternityTypes(data['maternity_limit'])
      setSumInsuredList(data['sum_insured'])
    } else {
      const {data} = await http.get('/business/get_plan_setup_details/')
      setBusinessType(data['business_type'])
      setSboInsurers(data['insurers'])
      setSumInsuredList(data['sum_insured'])
      data['group_accidental_cover'].forEach(cover => {
        if(cover['value'] === 0){
          cover['value'] = -1
        }
      })
      setupAccidentCoverAmout(data['group_accidental_cover'])
      setBenefitTypes(data['benefit_type'])
      setPolicyType(data['policy_type'])
      setDiscountType(data['discount_type'])
      setDependents(data['dependent_type'])
    }
    
    

    if(userplan_id) {
      try{
        let {data} = await http.get('/business/edit_plan/',{
          params: {
            userplan_id: userplan_id
          }
        })
        

        data = data?.data || {}
        // 

        setInitialValues({
          business_type: data['BUSINESS TYPE'],
          benefit_type: data['BENIFIT TYPE'],
          sbo_insurers: data['insurer'],
          discount_type: data['DISCOUNT TYPE'],
          dependent_type: data['DEPENDENT TYPE'],
          rewards_alloted: data['Reward Alloted'],
          policyDoc: flow === 'GMC' && '',
          policy: data['policy'],
          sum_insured_gpa: data['sum_insured_gpa'] || -1,
          sum_insured: data['sum_insured'] || '',

        })
        // selectedBusinessType(data['BUSINESS TYPE'])
      } catch(ex){
        console.log('can\'t prefetch data')
      }
      
    } else {
      if(flow === 'GMC'){
        setInitialValues({
          business_type:  '',
          benefit_type:  '',
          rewards_alloted: '',
          commission:'',
          room_type:'',
          maternity_limit:'',
          // dependent_type:  '',
          // insurer_name: '',
          sum_insured:'',
          sbo_insurers:''
        })
      } else {
        setInitialValues({
          business_type:  localStorage.getItem('business_type') || '',
          sbo_insurers: localStorage.getItem('sbo_insurers') || '',
          insurer_name: localStorage.getItem('insurer_name')||'',
          benefit_type:  localStorage.getItem('benefit_type') || '',
          sum_insured: localStorage.getItem('sum_insured') || '',
          discount_type:  localStorage.getItem('discount_type') || '',
          dependent_type:  localStorage.getItem('dependent_type') || '',
          rewards_alloted: localStorage.getItem('rewards_alloted') || '',
          commission: localStorage.getItem('commission') || 0,
          room_type: localStorage.getItem('room_type') || 0,
          maternity_limit: localStorage.getItem('maternity_limit') || 'NONE',
          sum_insured_gpa: localStorage.getItem('sum_insured_gpa') || 0,
          policy: localStorage.getItem('policy') || '',
        })
      }
      
    }

    setLoading(false)
  }

  useEffect(() => {
    getInitialValues()
  },[])

  
  
  let navigate =  useNavigate();
  

  const savePlanIdAndNavigate = (response) => {
    // if(flow === 'GMC'){
    //   navigate(`/${routes.UPLOAD_EXCEL}`);
    //   userPlanID && sessionStorage.setItem('userplan_id',userPlanID)
    // } else {
    //   window.history.pushState(null, null, '/')
    //   userPlanID && localStorage.setItem('userplan_id',userPlanID)
    //   navigate(`/${routes.CARE_DASHBOARD}`);
    // }
    if(response.sbo_insurers === 'go_digit'){
      navigate(`/${routes.UPLOAD_RATECHART}/onboarding`)
    } else if(flow === 'GMC'){
      navigate(`/${routes.RATE_CHART}/onboarding`)
    } else if(type === 'onboarding'){
      response && response['userplan_id'] && sessionStorage.setItem('userplan_id',response['userplan_id'])
      navigate(`/${routes.UPLOAD_EXCEL}/onboarding`);
    } else {
      window.history.pushState(null, null, '/')
      response && response['userplan_id']&& localStorage.setItem('userplan_id', response['userplan_id'])
      if(response['employee_reupload']){
        navigate(`/${routes.UPLOAD_EXCEL}/edit`);
      } else {
        navigate(`/${routes.CARE_DASHBOARD}`);
      }
      
    }
    
  }

  const handleChange = (event, setFieldValue, name, length) => {
    const value = event.target.value;
    setFieldValue(name, value.slice(0, length));
  };

  const onUpload = async (oEvent, formikProps, name) => {
    if (!oEvent?.target?.files[0]) {
        return
    }

    let formData = new FormData()
    formData.append('file_details', oEvent.target.files[0])

    try {
        // setLoading(true)

        if(userplan_id){
            formData.append('userplan_id', localStorage.getItem('userplan_id'))
            const { data } = await axios({

              url: config.apiUrl + '/insurance/upload_document/',
              method: 'POST',
              data: formData,
              headers: {
                  Accept: 'application/json',
                  'Content-Type': 'multipart/form-data',
              }

          })
            
        } else {
            formData.append('file_owner',localStorage.getItem('id'))
            formData.append('file_type', 'policy_document')
            const { data } = await axios({

                url: config.apiUrl + '/insurance/upload_document/',
                method: 'POST',
                data: formData,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data',
                }

            })
            formikProps.setFieldValue(name, {
              name: oEvent.target.files[0]['name'],
              id: data['id']
            })
        }
        

    } catch (ex) {
        oEvent.target.value = null
        if(ex.response && Array.isArray(ex.response.data)){
          formikProps.setFieldError(name, ex.response && ex.response.data)
        }
        
       
    }
    // setLoading(false)

}

  const renderInput = ({
    name,
    placeholder,
    type,
    formikProps,
    length = 70,
  } = {}) => {
    const { errors, touched, handleBlur, setFieldValue, values } = formikProps;
    const error = touched[name] && errors[name];
    return (
      <InputContainer>
        <Input
          value={values[name]}
          name={name}
          placeholder={placeholder}
          type={type}
          error={error}
          onChange={(event) =>
            handleChange(event, setFieldValue, name, length)
          }
          onBlur={handleBlur}
        />
      </InputContainer>
    );
  };

  const handleSubmit = async (values) => {
    if(is_click==true){
      return
    }
    setIsClick(true)
    setLoading(true)
  //  await this.setState({
  //     is_click:true
  //   })


    // await this.setState({ loading: true });
    localStorage.setItem('business_user_id',localStorage.getItem('id'))
    values.business_type && localStorage.setItem('business_type',values.business_type)
    values.sbo_insurers && localStorage.setItem('sbo_insurers', values.sbo_insurers)
    values.benefit_type && localStorage.setItem('benefit_type',values.benefit_type)
    values.sum_insured && localStorage.setItem('sum_insured', values.sum_insured)
    values.discount_type && localStorage.setItem('discount_type',values.discount_type)
    values.dependent_type && localStorage.setItem('dependent_type',values.dependent_type)
    values.rewards_alloted && localStorage.setItem('rewards',values.rewards_alloted)
    values.commission && localStorage.setItem('commission', values.commission)
    values.room_type && localStorage.setItem('room_type', values.room_type)
    values.maternity_limit && localStorage.setItem('maternity_limit', values.maternity_limit)
    values.policy && localStorage.setItem('policy',values.policy)
    values.sum_insured_gpa && localStorage.setItem('sum_insured_gpa', values.sum_insured_gpa)

    let {sum_insured_gpa} = values
    sum_insured_gpa = Number(sum_insured_gpa)
    sum_insured_gpa = sum_insured_gpa <= 0 ? 0 : (sum_insured_gpa || 0)
    if(values.sbo_insurers === 'go_digit' || flow === 'GMC'){
      savePlanIdAndNavigate(values)
    }
    else {
      try {
      let resp =await http.post("/business/setupplan/", {
        business_user_id:localStorage.getItem('id'),
        policy: values.policy,
        business_type:values && values.business_type,
        benefit_type:values && values.benefit_type,
        discount_type:values && values.discount_type ,
        dependent_type:values && values.dependent_type ,
        rewards:values && values.rewards_alloted,
        insurer_name: values && values.insurer_name,
        document_id: values && values.policyDoc && values.policyDoc.id,
        sum_insured_gpa,
        sum_insured: values && values.sum_insured
      });
      localStorage.removeItem('source')
      localStorage.removeItem('company_name')
      localStorage.removeItem('city')
      localStorage.removeItem('pincode')
      localStorage.removeItem('gstno')
      localStorage.removeItem('primary_contact_name')
      localStorage.removeItem('primary_contact_email')
      localStorage.removeItem('primary_contact_mobile')
      localStorage.removeItem('phone')
      localStorage.removeItem('secondary_contact_name')
      localStorage.removeItem('secondary_contact_email')
      localStorage.removeItem('secondary_contact_mobile')
      savePlanIdAndNavigate(resp.data)

    } catch (ex) {
      setLoading(true)
    //  await  this.setState({ loading: false });
      const error = ex.response && ex.response.data;
      
      console.error(ex);
    }}
    setIsClick(false)
    // await this.setState({
    //   is_click:false,
    // })
  };

 

  const renderError = (formikProps, name, style) => {
    const { touched, errors, } = formikProps
    let touch = touched && touched[name]
    let error = errors && errors[name]
    return (
      <Error style={style}>
        {touch && error}
      </Error>
    )
  }

  const renderInsurerTypeDropdown = ({formikProps}) => {
    const { values, setFieldTouched, handleChange, setFieldValue } = formikProps
    const value = values && values['sbo_insurers']
    const onChangeInsurer = (event) => {
      handleChange(event)
      setFieldValue('business_type',"")
      setFieldValue('dependent_type', "")
      setFieldValue('sum_insured', "")
      setFieldValue("benefit_type", "")
    } 
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={'sbo_insurers'}
            onChange={onChangeInsurer}
            onBlur={(e => setFieldTouched('sbo_insurers', true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'INSURER TYPE'}
            </Option>
            {sbo_insurers && sbo_insurers.map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'sbo_insurers')}
      </DropdownComponentWrapper>
    )
  }


  const renderGmcInsurerTypeDropdown = ({formikProps}) => {
    const { values, setFieldTouched, handleChange, setFieldValue } = formikProps
    const value = values && values['sbo_insurers']
    const onChangeInsurer = (event) => {
      handleChange(event)
      // setFieldValue('business_type',"")
      setFieldValue('sum_insured', "")
      setFieldValue("business_type","")
      setFieldValue("benefit_type", "")
      setFieldValue("room_type", "")
      // maternityLimitShow && setFieldValue("maternity_limit", "")
    } 
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={'sbo_insurers'}
            onChange={onChangeInsurer}
            onBlur={(e => setFieldTouched('sbo_insurers', true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'INSURER'}
            </Option>
            {sbo_insurers && sbo_insurers.map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'sbo_insurers')}
      </DropdownComponentWrapper>
    )
  }

  const renderPlanTypeDropDown = ({formikProps, name}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const business_type_value = values && values['sbo_insurers']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={'business_type'}
            onChange={handleChange}
            onBlur={(e => setFieldTouched('business_type', true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'PRODUCT TYPE'}
            </Option>
            {business_type?.[business_type_value]?.map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'business_type')}
      </DropdownComponentWrapper>
    )
  }
  console.log(maternityLimitShow,"global")

  const renderGmcPlanTypeDropDown = ({formikProps, name}) => {
    const { values, setFieldTouched, handleChange, setFieldValue } = formikProps
    const value = values && values[name]
    const onChangeMaternityType = (event) => {
      handleChange(event)
      setFieldValue('sum_insured', "")
      setFieldValue("benefit_type", "")
      setFieldValue("room_type", "")
      // maternityLimitShow?setFieldValue("maternity_limit", "NONE"):setFieldValue("maternity_limit", "")
     
    }
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={'business_type'}
            onChange={onChangeMaternityType}
            onBlur={(e => setFieldTouched('business_type', true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'MATERNITY'}
            </Option>
            {business_type && business_type.map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
                {(value === 'GMC_M')?setMaternityLimit(true):setMaternityLimit(false)}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'business_type')}
      </DropdownComponentWrapper>
    )
  }

  const renderPlanSumInsuredDropdown = ({formikProps}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const name = 'sum_insured'
    const value = values && values[name]
    const business_type_value = values && values['business_type'] 
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'SUM INSURED'}
            </Option>
            {sum_insured_list && sum_insured_list[business_type_value] && sum_insured_list[business_type_value].map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }


  const renderGmcPlanSumInsuredDropdown = ({formikProps}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const name = 'sum_insured'
    const value = values && values[name]
    const plantype = formikProps && formikProps.values['business_type']
    const insurer = formikProps && formikProps.values['sbo_insurers']
   
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
           value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
             <Option value='' default disabled selected hidden>
                        {'SUM INSURED'}
            </Option>
            {sum_insured_list && sum_insured_list[plantype] && sum_insured_list[plantype][insurer] && sum_insured_list[plantype][insurer].map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderBenefitTypeDropDown = ({formikProps, name, placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const business_type_value = values && values['business_type']

    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={values.benefit_type}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
           <Option value='' default disabled selected hidden>
                        {placeholder}
            </Option>
            {benefit_types?.[business_type_value]?.map((item, key) => (
            <Option value={item['value']} key={key} >
              {item['display_name']}
            </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderBenefitTypeDropDownSecond = ({name,formikProps,placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const insurer = formikProps && formikProps.values['insurer_name']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden >
                        {placeholder}
            </Option>
            {benefit_types && benefit_types[insurer] && benefit_types[insurer].map((item, key) => (
              <Option value={item} key={key} >
                {item}
            {/* {benefit_types[values['insurers'] || '']?.map((item, key) => (<Option value={item} key={key} >
              {item} */}
              </Option>
            ))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }


  const renderGmcBenefitTypeDropDown = ({name,formikProps,placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const plantype = formikProps && formikProps.values['business_type']
    const insurer = formikProps && formikProps.values['sbo_insurers']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden >
                        {placeholder}
            </Option>
            {benefit_types && benefit_types[plantype] && benefit_types[plantype][insurer] && benefit_types[plantype][insurer].map((item, key) => 
             
                (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>
            ))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderRoomTypeDropDown = ({name,formikProps,placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const plantype = formikProps && formikProps.values['business_type']
    const insurer = formikProps && formikProps.values['sbo_insurers']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden >
                        {placeholder}
            </Option>
            {room_types && room_types[plantype] && room_types[plantype][insurer] && room_types[plantype][insurer].map((item, key) => (
              <Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>
            ))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderMaternityLimitTypeDropDown = ({name,formikProps,placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const plantype = formikProps && formikProps.values['business_type']
    const insurer = formikProps && formikProps.values['sbo_insurers']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden >
                        {placeholder}
            </Option>
            {maternity_types && maternity_types[plantype] && maternity_types[plantype][insurer] && maternity_types[plantype][insurer].map((item, key) => (
              <Option value={item['value']} key={key} >
                {item['display_name']}
            {/* {benefit_types[values['insurers'] || '']?.map((item, key) => (<Option value={item} key={key} >
              {item} */}
              </Option>
            ))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderAccidentCoverDropDown = ({formikProps, name, placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
           <Option value={0} default disabled selected hidden>
                        {placeholder}
            </Option>
            {AccidentCoverAmount?.map((item, key) => (
              <Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))
            }
            
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderDiscountTypeDropDown = ({formikProps, name}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    const business_type_value = values && values['sbo_insurers']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
          value={values.discount_type}
            name={'discount_type'}
            onChange={handleChange}
            onBlur={(e => setFieldTouched('discount_type', true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden >
                        {'DISCOUNT TYPE'}
            </Option>
            {discount_type?.[business_type_value]?.map((item, key) => 
              (<Option value={item['value']} key={key} >
                {item['display_name']}
              </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'discount_type')}
      </DropdownComponentWrapper>
    )
  }

  const renderDependentTypeDropDown = ({formikProps}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values['dependent_type']
    const business_type_value = values && values['business_type'] 

    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
          value={values.dependent_type}
            name={'dependent_type'}
            onChange={handleChange}
            onBlur={(e => setFieldTouched('dependent_type', true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden>
                        {'DEPENDENT TYPE'}
            </Option>
            {dependent_type[business_type_value] &&  dependent_type[business_type_value].map((item, key) => (
            <Option value={item['value']} key={key} >
              {item['display_name']}
            </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, 'dependent_type')}
      </DropdownComponentWrapper>
    )
  }

  const renderPolicyTypeDropDown = ({formikProps, name}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values[name]
    
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
          value={value}
            name={name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden>
                        {'POLICY TYPE'}
            </Option>
            {policyTypes && policyTypes.map((item, key) => (
            <Option value={item['value']} key={key} >
              {item['display_name']}
            </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderInsurerDropDown = ({formikProps, name, placeholder}) => {
    const { values, setFieldTouched, handleChange } = formikProps
    const value = values && values['insurer_name']
    return (
      <DropdownComponentWrapper>
        <DropdownWrapper>
          <AgeWrapper
            value={value}
            name={insurer_name}
            onChange={handleChange}
            onBlur={(e => setFieldTouched(name, true))}
            color={value && '#009999'}
          >
            <Option value='' default disabled selected hidden>
                        {placeholder}
            </Option>
            {insurer_name && insurer_name.map((item, key) => (<Option value={item} key={key} >
              {item['display_name']}
            </Option>))}
          </AgeWrapper>
          <Icons style={{ 'position': 'absolute', 'marginLeft': '74%' }} icon='chevron_down' fill="#7e7b7f" />
        </DropdownWrapper>
        {renderError(formikProps, name)}
      </DropdownComponentWrapper>
    )
  }

  const renderForm = (formikProps) => {
    const isDisabled =
      formikProps &&
      formikProps.values &&
      Object.values(formikProps.values).filter((item) => !item).length > 0;
      
    return (
      <HomeWrapper>
        <Form>
         <Ptag
            fontSize="24px"
            fontWeight="600"
            letterHeight="1.33"
            letterSpacing="0.35px"
          >
            {"Build your plan"}
          </Ptag>
          

          {flow === 'GMC' ?
            <>
              {/* {renderInsurerDropDown({name:'insurer_name', placeholder:'INSURER', type:'text', formikProps})} */}
              {renderGmcInsurerTypeDropdown({name: 'sbo_insurers', placeholder:'INSURERS', type:'text', formikProps})}
              {renderGmcPlanTypeDropDown({name:'business_type', placeholder:'MATERNITY TYPE', type:'text', formikProps})}
              {/* {maternityLimitShow && renderMaternityLimitTypeDropDown({name:'maternity_limit', placeholder:'MATERNITY LIMIT', type:'text', formikProps})} */}
              {renderRoomTypeDropDown({name:'room_type', placeholder:'ROOM TYPE', type:'text', formikProps})}
              {renderGmcPlanSumInsuredDropdown({name:'sum_insured', placeholder:'SUM INSURED', type:'text', formikProps})}
              {renderGmcBenefitTypeDropDown({name:'benefit_type', placeholder:'WELLNESS BENEFIT', type:'text', formikProps})}
              {renderInput({
                name: "rewards_alloted",
                placeholder: "REWARDS ALLOTED",
                type: "number",
                formikProps,
              })}
              {renderInput({
                name: "commission",
                placeholder: "COMMISSION",
                type: "number",
                formikProps,
              })}
              {/* {renderUploadPolicyDoc({name: 'policyDoc', formikProps })} */}

            </>:
            <>
              {renderPolicyTypeDropDown({name:'policy', placeholder:'POLICY TYPE', type:'text', formikProps})}
              {renderInsurerTypeDropdown({name: 'sbo_insurers', placeholder:'INSURERS', type:'text', formikProps})}
              {renderPlanTypeDropDown({name:'business_type', placeholder:'PLAN TYPE', type:'text', formikProps})}
              {renderPlanSumInsuredDropdown({name:'sum_insured', placeholder:'SUM INSURED', type:'text', formikProps})}
              {renderBenefitTypeDropDown({name:'benefit_type', placeholder:'BENEFIT TYPE', type:'text', formikProps})}
              {renderAccidentCoverDropDown({name:'sum_insured_gpa', placeholder:'GROUP ACCIDENT COVER', type:'text', formikProps})}
              {renderDiscountTypeDropDown({name:'discount_type', placeholder:'DISCOUNT TYPE', type:'text', formikProps})}
              {renderDependentTypeDropDown({name:'dependent_type', placeholder:'DEPENDENT TYPE', type:'text', formikProps})}

              {renderInput({
                name: "rewards_alloted",
                placeholder: "REWARDS ALLOTED",
                type: "number",
                formikProps,
              })}
            </>
              
          }          
          <ButtonWrapper>
            <LargeButton
              // disabled={isDisabled}
              // opacity={isDisabled ? "0.4" : "1"}
              id="business_about_next12"
              label="Save & Next"
              type="submit"
              // onClick={handleSubmit}
            />
          </ButtonWrapper>
        </Form>
      </HomeWrapper>
    );
  };

  let Schema;
  if( flow === 'GMC'){
    if(maternityLimitShow)
    {
      Schema = Yup.object().shape({
      sbo_insurers: Yup.string().required('*required'),
      business_type: Yup.string().required('*required'),
      benefit_type: Yup.string().required('*required'),
      sum_insured: Yup.string().required('*required'),
      rewards_alloted: Yup.number().min(0).required("*required"),
      commission: Yup.number().min(0).required("*required"),
      room_type: Yup.string().required("*required"),
      // maternity_limit: Yup.string().required("*required"),
    });
  }else {
      Schema = Yup.object().shape({
        sbo_insurers: Yup.string().required('*required'),
        business_type: Yup.string().required('*required'),
        benefit_type: Yup.string().required('*required'),
        sum_insured: Yup.string().required('*required'),
        rewards_alloted: Yup.number().min(0).required("*required"),
        commission: Yup.number().min(0).required("*required"),
        room_type: Yup.string().required("*required"),
        // maternity_limit: Yup.string().required("*required"),
      }); 
  }

  } else {
    Schema = Yup.object().shape({
      sbo_insurers: Yup.string().required('*required'),
      business_type: Yup.string().required('*required'),
      benefit_type: Yup.string().required('*required'),
      sum_insured: Yup.string().required('*required'),
      discount_type: Yup.string().required('*required'),
      rewards_alloted: Yup.number().min(0).required("*required"),
      dependent_type: Yup.string().required("*required"),
      policy: Yup.string().required("*required"),
      sum_insured_gpa: Yup.number().test('sum','*required', val => val != 0 ),
    });
  }
  
  

    return (
      <>
        <SideNav>
          {
            showSidebar() && 
            <SideNavContent />
          }
          
        </SideNav>
        <Root>
        {loading ? <OverlayLoader /> :
            <Formik
              enableReinitialize={true}
              initialValues={initialValues}
              validationSchema={Schema}
              onSubmit={handleSubmit}
              render={(formikProps) => renderForm(formikProps)}
            />
        }
        </Root>
      </>
      
    );
}
// }


const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;




const InputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  margin-top:60px;
`;

const Error = styled.p`
  color: red;
  font-size: 1.4rem;
  margin-top: 4rem;
  position: absolute;
  z-index: 9;
`

const DropdownComponentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 30px;
`;

const DropdownWrapper = styled.div`
    display: flex;
    padding: 6px;
    border-bottom: 2px solid #436ab2;
    align-items: center;
`;


const AgeWrapper = styled.select`
    display: flex;
    width: 100%;
    border: none;
    font-family: "Inter";
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    color: ${props => props.color ? props.color : 'rgba(0, 0, 0, 0.5)'};
    background-color: transparent;
    -webkit-appearance: none;
    -moz-appearance: none;
    &:hover,
    &:focus 
    {
      outline: 0 !important;
    };
`;

const Option = styled.option`
 color: ${props => props.color ? props.color : 'black'};
`

const HomeWrapper = styled.div`
  margin-left: 252px;
  transition: margin-left .2s ease-in;
  padding: 50px 80px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  
`


const UploadButton = styled.div`
    display: flex;
    margin-top: 60px;
    border: 1px dashed #436AB2;
    border-radius: 10px;
    padding: 48px;
    justify-content: center;
    cursor: pointer;
    & > input{
        display: none;
    }  
`

const UploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export default About